<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-playlist-plus
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Create Employees DoE"
      text="Bluk Create Employees Fixed DoE"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="3"
              lg="3"          
              md="12"
              sm="12"
              xl="3"
            >
              <v-row>
                <v-col
                  cols="12"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="doe.name"
                    v-validate="'required'" 
                    label="Name"
                    :disabled="true"
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"    
                    data-vv-as="name" 
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="amount"
                    v-money="money"
                    v-validate="'required'" 
                    label="Amount"
                    :error-messages="errors.collect('amount')"
                    data-vv-name="amount"    
                    data-vv-as="amount" 
                    prefix="RM"
                  />
                </v-col>

                <v-col cols="12">
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDateDisplay"
                        v-validate="'required'"
                        label="Start Date"
                        outlined
                        readonly
                        data-vv-as="start date"
                        class="label-position" 
                        :error-messages="errors.collect('startDateDisplay')"
                        data-vv-name="startDateDisplay"
                        :class="{
                          'required':!startDateDisplay
                        }"    
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @input="startDateMenu = false"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <v-menu
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDateDisplay"
                        v-validate="'endDateRule'"
                        label="End Date"
                        outlined
                        readonly
                        data-vv-as="end date"
                        class="label-position" 
                        :error-messages="errors.collect('endDateDisplay')"
                        data-vv-name="endDateDisplay"
                        :class="{
                          'required':!endDateDisplay
                        }"    
                        :disabled="!endDateDisplay"
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @input="endDateMenu = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>

            <!-- Employees filter -->
            <v-col
              cols="9"
              lg="9"          
              md="12"
              sm="12"
              xl="9"
            >
              <v-card class="pa-4 elevation-5">
                <v-text-field
                  v-model="searchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />
                <v-autocomplete
                  v-model="filters.companies"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Companies"
                  placeholder="Filter employee by company"
                  clearable
                  hide-selected
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      close
                      class="chip--select-multi"
                      @click:close="remove('companies', data.item)"
                    >
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-model="filters.jobCategories"
                  :items="jobCategories"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Job Category"
                  placeholder="Filter employee by job category"
                  clearable
                  hide-selected
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      close
                      class="chip--select-multi"
                      @click:close="remove('jobCategories', data.item)"
                    >
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-model="filters.positions"
                  :items="positions"
                  item-text="label"
                  item-value="id"
                  value="id"
                  label="Position"
                  placeholder="Filter employee by position"
                  clearable
                  hide-selected
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      close
                      class="chip--select-multi"
                      @click:close="remove('positions', data.item)"
                    >
                      {{ data.item.label }}
                    </v-chip>
                  </template>
                </v-autocomplete>
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="headers"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  show-select
                  class="elevation-1 mb-3"
                  height="335px"
                  :error-messages="errors.collect('selectedEmployees')"
                  data-vv-name="selectedEmployees"
                  data-vv-as="employee selection"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Employee Selection:</v-toolbar-title>
                    </v-toolbar>
                  </template>
                </v-data-table>
                <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                  <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      doe: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        amount: 0,
        startDate: null,
        endDate: null,
        searchInput: '',
        filters: {
          // departments: '',
          positions: '',
          jobCategories: '',
          companies: '',
        },
        tableLoading: false, 
        // departments: [],
        companies: [],
        positions: [],
        employees: [],
        jobCategories: [],
        selectedEmployees: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'employee.person.name',
          },
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company.name',
          }, 
          {
            text: 'Job Category',
            align: 'left',
            sortable: true,
            value: 'employee.current_position.position.job_grade.job_category.name',
          },
          {
            text: 'Position',
            align: 'left',
            sortable: true,
            value: 'employee.current_position.position.name',
          },
        ],
        startDateMenu: false,
        endDateMenu: false,
        appOrg: process.env.VUE_APP_ORG,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (companyEmployee) {
          return ((companyEmployee.employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 ||
            ((companyEmployee.employee.person || {}).username || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })
        let filteredPositions = this.customFilterPositions(primaryFilterEmployees)
        let filteredJobCategories = this.customFilterJobCategories(filteredPositions)
        let filteredCompanies = this.customFilterCompanies(filteredJobCategories)
        // let filteredDepartment = this.customFilterDepartments(filteredJobCategories)
        
        return filteredCompanies
      },

      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },

      endDateDisplay () {
        return this.endDate ? this.$moment(this.endDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        this.loadCompanies()
        this.loadPositions()
        this.loadEmployees()
        this.loadJobCategories()

        this.loading = false
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('endDateRule', {
        getMessage (field, args) {
          return 'Start date must earlier or equal to end date'
        },
        validate (value, args) {
          return _this.isValidEndDate(value)
        },
      })
    },
    methods: { 
      loadCompanies () {
        this.$api.hrisCompanies().list('?organization=' + this.appOrg)
          .then((res) => {
            this.companies = _.orderBy(res.data, ['name'], ['asc'])  
          })
          .catch(() => {})
      },
      loadPositions () {
        this.$api.positions().list()
          .then(res => {
            this.positions = res.data.map(pos => ({
              id: pos.id,
              label: `${pos.name} (${pos.job_grade.job_group.name})`,
            }))
          })
          .catch(() => {})
      },
      loadEmployees () {
        this.$api.hrisCompanyEmployees().list('?with=organization')
          .then(res => {
            this.employees = _.orderBy(res.data, ['employee.person.name'], ['asc'])
            this.tableLoading = false
          })
          .catch(() => {})
      },
      loadJobCategories () {
        this.$api.jobCategories().list()
          .then(res => {
            this.jobCategories = _.orderBy(res.data, ['name'], ['asc'])  
            this.tableLoading = false
          })
          .catch(() => {})
      },
      customFilterPositions (employeesList) {
        if (this.filters.positions.length === 0) return employeesList

        return employeesList.filter(companyEmployee => {
          let positionId = (companyEmployee.employee.current_position || {}).position_id

          return _.intersection([positionId], this.filters.positions).length > 0
        })
      },
      customFilterJobCategories (employeesList) {
        if (this.filters.jobCategories.length === 0) return employeesList

        return employeesList.filter(companyEmployee => {
          let jobCategoryId = ((((companyEmployee.employee.current_position || {}).position || {}).job_grade).job_category || {}).id

          return _.intersection([jobCategoryId], this.filters.jobCategories).length > 0
        })
      },
      customFilterCompanies (employeesList) {
        if (this.filters.companies.length === 0) return employeesList

        return employeesList.filter(companyEmployee => {
          let companyUid = companyEmployee.company.id

          return _.intersection([companyUid], this.filters.companies).length > 0
        })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.companyEmployeeDeductionOrEarnings().createMany(this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('created')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
              .catch(err => {
                if (err.response.status === 400) {
                  this.$dialog({
                    title: 'Warning',
                    message: err.response.data.message,
                    color: 'error',
                  })
                } else {
                  this.$snack({
                    color: 'error',
                    message: 'Unable to bulk create fixed DOE',
                  })
                }
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          deduction_or_earning_id: this.doe.id,
          amount: this.amount.toString().replaceAll(',', ''),
          start_date: this.startDate,
          end_date: this.endDate,
          company_employees: this.selectedEmployees,
        }
      },
      isValidEndDate (value) {
        return this.$moment(this.endDate, 'YYYY-MM-DD') >= this.$moment(this.startDate, 'YYYY-MM-DD')
      },
      remove (key, item) {
        let index = this.filters[key].findIndex(selectedId => selectedId === item.id)

        if (index >= 0) this.filters[key].splice(index, 1)
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
